import { FilterRequirementsAutocomplete } from '../baseInputTypes/FilterRequirementsAutocomplete'

type Props = {}
export const SubIndustries = (props: Props) => (
  <FilterRequirementsAutocomplete
    label="Sub-Industries"
    fieldName={'subIndustries'}
    fieldPath={'documentInformation.subIndustries'}
  />
)
